import { useRouter } from 'next/router';
import { usePrevPage } from './usePrevPage';

export const useBackNavigation = (
  fallbackRoute: string,
  isPrevPageInternal?: boolean,
) => {
  const router = useRouter();

  // If isPrevPageInternal is not provided, we compute it
  if (typeof isPrevPageInternal === 'undefined') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isPrevPageInternal: computedValue } = usePrevPage();
    isPrevPageInternal = computedValue;
  }

  const navigateBack = (params?: Record<string, string | number>) => {
    const finalParams = new URLSearchParams();

    if (typeof params === 'object') {
      // Add object keys and values as parameters
      for (const [key, value] of Object.entries(params)) {
        if (value) finalParams.append(key, String(value));
      }
    }

    if (isPrevPageInternal) {
      router.back();
    } else {
      router.push(`${fallbackRoute}?${finalParams.toString()}`);
    }
  };

  return { navigateBack };
};
